<div class="full-page-background">
  <p-card styleClass="hero-card component blue-section">
    <div class="hero-layout">

      <div class="hero-text">
        <h4>{{region.toUpperCase()}}</h4>
        <h1 class="hero-title">
          Electric Outage Reporting
        </h1>

        <!-- <button class="cta-button">
        <span class="signup-text">Sign up today!</span>
      </button> -->
      </div>

      <div class="hero-image">
        <img src="../../assets/images/hero_image.png" />
      </div>



    </div>
  </p-card>
  <div class="report-container">
    
    <div class="enroll-form">
      <h4 class="mb-4" style="font-size:2.5rem; font-weight: 700;">Report an Outage</h4>
      <div class="mt-3 infor">
        <p>
          See a downed power line? Stay at least 35 feet away and call us at
          {{ emergencyNumber }}. <br />
        </p>
      </div>
      <br />
      @if (isLoading) {
      <div class="loading-container overlay">
        <p-progressSpinner strokeWidth="4">
          <style class="custom-spinner"></style>
        </p-progressSpinner>
      </div>
      }

      <form #pasLightPreferenceForm="ngForm" (ngSubmit)="onSubmit(pasLightPreferenceForm, $event)">
        <div>
          <!--Phone or Meter Number-->
          <div style="display: none;">
            <div>
              <label for="phoneOrMeterField" class="bold-label">PHONE OR METER NUMBER*</label>
            </div>
            <div class="phone-or-meter-row">
              <div class="col-sm-4 col-lg-4">
                <input type="text" class="form-control form-textbox" id="phoneOrMeterField" #phoneField="ngModel"
                  [(ngModel)]="phoneMeterNumber" name="phoneOrMeterNumber" (blur)="validatePhoneOrMeterNumber()"
                  required />
              </div>
              <a href="javascript:void(0);" class="help-link" aria-label="Show phone or meter example">
                ?
                <img src="../../assets/images/meternumber.jpg" alt="Phone or meter example" class="help-image" />
              </a>
            </div>

            <div class="errorMessage">
              @if (!isPhoneOrMeterValid || phoneField.invalid) {
              <p>{{ phoneOrMeterErrorMessage }}</p>
              }
            </div>
          </div>
          <div class="account-number-field">
            <div class="label-row">
              <span class="field-label">
                Phone Number / Meter Number
                <span class="required">*</span>
              </span>
              <button type="button" class="find-account-link" (click)="openAccountHelp('meter')">
                (Find Your Meter Number)
              </button>
            </div>

            <div class="input-container">
              <input type="text" maxlength="12" id="phoneOrMeterField" name="phoneOrMeterNumber" #phoneMeterField="ngModel"
                [(ngModel)]="phoneMeterNumber" (blur)="validatePhoneOrMeterNumber()" [class.invalid]="phoneMeterField.touched && !isPhoneOrMeterValid" />
              <div class="errorMessage">
                @if (phoneMeterField.touched && !isPhoneOrMeterValid) {
                <p>{{ phoneOrMeterErrorMessage }}</p>
                }
              </div>
            </div>
          </div>
          <!--House Number-->
          <div style="display: none;">
            <div>
              <label for="houseNumField" class="bold-label">STREET NUMBER* (Do not enter street name)</label>
            </div>
            <div class="phone-or-meter-row">
              <div class="col-sm-4 col-lg-4">
                <input type="text" class="form-control form-textbox" id="houseNumField" #houseField="ngModel"
                  [(ngModel)]="houseNumber" name="houseNumber" (blur)="validateHouseNum()" required />
              </div>
              <a href="javascript:void(0);" class="help-link" aria-label="Show house number example">
                ?
                <img src="../../assets/images/streetnumber.jpg" alt="Street number example" class="help-image" />
              </a>
            </div>

            <div class="errorMessage">
              @if (!isHouseNumValid || houseField.invalid) {
              <p>{{ houseNumberErrorMessage }}</p>
              }
            </div>
          </div>
          <div class="account-number-field">
            <div class="label-row">
              <span class="field-label">
                Street Number (Do not enter street name)
                <span class="required">*</span>
              </span>
              <button type="button" class="find-account-link" (click)="openAccountHelp('street')">
                (Find Your Street Number)
              </button>
            </div>

            <div class="input-container">
              <input type="text" maxlength="12" id="houseNumField" [(ngModel)]="houseNumber" #houseNumberField="ngModel"
                (blur)="validateHouseNum()" [class.invalid]="houseNumberField.touched && !isHouseNumValid" name="houseNumber" />
              <div class="errorMessage">
                @if (houseNumberField.touched && !isHouseNumValid) {
                <p>{{ houseNumberErrorMessage }}</p>
                }
              </div>
            </div>
          </div>
          <br />
        </div>

        @if (isLoading) {
        <div class="loading-container overlay">
          <p-progressSpinner strokeWidth="4">
            <style class="custom-spinner"></style>
          </p-progressSpinner>
        </div>
        }

        <div>
          @if (showEopBlock && region.toLowerCase() === "texas") {
          <label class="acknowledgement-content"><b>Read and select the box below to continue.</b></label>
          }
        </div>
        <div>
          @if (showEopBlock && region.toLowerCase() === "texas") {
          <div class="checkbox-ack-info">
            <input type="checkbox" class="checkboxx" name="confirmEligibility" [(ngModel)]="isEligible"
              id="confirmEligibility" [required]="showEopBlock" />
            <div>
              <p class="checkboxx-info">
                Please note, on our site visit if our technician is unable to
                access the CenterPoint Energy equipment located on your premise,
                or determines the problem was caused by your equipment, like a
                tripped circuit breaker or blown fuse,
                @if (region.toLowerCase() === "texas") {
                <span>CenterPoint Energy may charge a fee of $125 to your retail
                  provider, who in turn may charge you.</span>
                }
                If you have not checked your circuit breaker yet, check it first
                and if you are still experiencing issues, please continue
                reporting this outage.
              </p>
              <br />
              <!-- <p class="checkboxx-info-note">
                          ***Not applicable for IN electric customers - please check this box to proceed with
                          reporting an
                          outage.
                        </p> -->
            </div>
          </div>
          }
        </div>
        <div class="input-container">
          <label class="bold-label" [ngClass]="isEligible ? 'enabled-label' : 'disabled-label'">TYPE OF OUTAGE</label>

          <app-dropdown [options]="outageTypes" [selectedValue]="selectedOutageType"
            (selectedValueChange)="onOutageTypeChange($event)" [placeholder]="this.selectedOutageType" required
            [disabled]="!isEligible">
          </app-dropdown>
        </div>
        <br />
        <br />
        <div style="align-items: center; gap: 10px">
          <div [class.disabled-div]="
            !pasLightPreferenceForm.valid ||
            !ispasLightPreferenceForm ||
            !isEligible ||
            selectedOutageType === null
          ">
            <button class="cta-button" type="button" id="btnReCaptcha" outlined="true"
              (click)="handleSubmitButtonClick($event, pasLightPreferenceForm)">
              Submit
            </button>
          </div>
        </div>
      </form>
    </div>
  </div>
</div>
@if (showPopup) {
<app-enrollment-response [data]="apiResponse" (closePopup)="refreshRecaptchaToken()"></app-enrollment-response>
}
<p-dialog [(visible)]="accountHelpVisible" [header]="accountHelpTitle" [modal]="true" [closable]="true"
  [dismissableMask]="true" [draggable]="false" [resizable]="false" styleClass="account-help-dialog">
  <img [src]="accountHelpImage" [alt]="accountHelpTitle" class="account-help-image" />
</p-dialog>
<!-- Note: disclaimer script works only with anchor tags. It specifically looks for const selector = "a[href]"; in the scrit. -->
<!-- <a class="btn btn-primary"
          href="https://centerpointenergytx.clearesult.com"
          target="_blank"
        >Test Disclaimer Link</a> -->